export default {
  errorBoundaryHeader: 'Sorry…we’re experiencing a problem.',
  errorBoundarySubHeader: 'Please refresh the page to try again.',
  errorBoundaryWithRefreshSubHeader: 'Please click below to refresh.',
  refreshButtonLabel: 'Refresh',
};
